import { render } from "./CardText.vue?vue&type=template&id=7eaede39"
import script from "./CardText.vue?vue&type=script&lang=js"
export * from "./CardText.vue?vue&type=script&lang=js"
script.render = render

export default script